import { DateTime } from 'luxon'

const toDaysFn = (value) => {
  if (!value) value = 7
  const daysStr = value === 1 ? 'Day' : 'Days'
  return `${value} ${daysStr}`
}

const usDateTimeFn = (value) => {
  if (!value) {
    return ''
  } else {
    return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT)
  }
}

export default {
  toDays: toDaysFn,
  usDateTime: usDateTimeFn
}
